module.exports = __webpack_public_path__ + "static/media/rack-wallpaper3.79758126.jpg";